import styled from "@emotion/styled";
import { MOBILE_SCREEN, WARNING_GRADIENT } from "./theme";
import { ParagraphSmall } from "./typography/Paragraph";

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const StyledBadge = styled.div`
  background: ${WARNING_GRADIENT};
  padding: 12px 24px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  text-align: center;
  white-space: nowrap;
  margin-left: auto;

  ${MOBILE_SCREEN} {
    padding: 8px 16px;
    align-self: flex-start;
    margin-left: 0;
  }
`;

export const Badge: React.FC<BadgeProps> = ({ children, className, style }) => {
  return (
    <StyledBadge className={className} style={style}>
      <ParagraphSmall>{children}</ParagraphSmall>
    </StyledBadge>
  );
};
